<script setup>
import { onMounted, ref } from "vue";
import { getProjectsAPI } from "@/services/projects";
import { DocumentDuplicateIcon, InformationCircleIcon } from "@heroicons/vue/24/outline";

const apiOptions = [
  { key: 'contactabilidad', label: 'Validar y Registrar envío', description: 'Permite validar si un usuario está disponible para ser contactado a través de diferentes canales y registra la comunicación realizada. ✔️ Ideal para flujos donde se desea evaluar y registrar el contacto en una sola operación atómica.' },
  { key: 'evaluacion', label: 'Validar Disponibilidad de Contacto', description: 'Permite monitorear y analizar el comportamiento de los usuarios después de ser contactados.' },
  { key: 'registro', label: 'Registrar Envío de Contacto', description: 'Este servicio registra que un usuario fue contactado en una fecha específica.' },
  { key: 'catalogos', label: 'Servicios Catálogos', description: 'Permite consultar catálogos de datos auxiliares para la operación de los servicios.' }
];
const selectedApi = ref(null);

const proyects = ref([]);
const selectedProject = ref(0);
const selectedKey = ref(0);
const selectedMessage = ref(0);
const selectedCode = ref("");
const selectedDate = ref("");
const method_endpoint = ref("POST /api/v1/contact-service");
const url = "https://gcp-api.nateevo.com/api/v1/contact_service";

getProjectsAPI().then(response => {
  console.log("Fetched Projects:", response.data);
  proyects.value = response.data
  console.log("PROYECTS:", proyects.value.length);
})

const channelsArray = ref([]);
const messageArray = ref([]);
const handleProjectChange = async (event) => {
  console.log(event.target.value)
  selectedProject.value = event.target.value //
  console.log('Selected Project:', selectedProject.value); 
  const response = proyects.value.find(project => project.projectsId === parseInt(selectedProject.value));
    console.log("Fetched Channels:", response);
    channelsArray.value = response.channels;
    messageArray.value = response.communications
};

const handleKeyChange = async (event, text) => {
  const keyId = event.target.value;
  console.log("text", keyId, text);
  // selectedKey.value = keys.find(key => key.id === parseInt(keyId));
  console.log("Selected Key:", selectedKey.value);
};

const handleTypeChange = async (event) => {
  const keyId = event.target.value;
  console.log(event.target);
};

const handleDateChange = async (event) => {
  selectedDate.value = event.target.value;
  console.log("Selected Date:", selectedDate.value);
};

const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text);
};

const isTooltipVisible = false;
</script>
<template>
  <div>
    <div v-if="!selectedApi" class="api-selection">
      <h2>¿Qué servicio deseas ocupar?</h2>
      <div class="api-options-grid">
        <div v-for="option in apiOptions" :key="option.key" class="api-option-block-grid">
          <div class="api-option-img">
            <svg v-if="option.key === 'contactabilidad'" width="48" height="48" fill="none" viewBox="0 0 24 24" stroke="#21707b" stroke-width="1.5"><circle cx="12" cy="12" r="10" stroke="#21707b" stroke-width="2" fill="#eaf6fa"/><path d="M8 12l2 2 4-4" stroke="#21707b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            <svg v-else-if="option.key === 'evaluacion'" width="48" height="48" fill="none" viewBox="0 0 24 24" stroke="#21707b" stroke-width="1.5"><rect x="4" y="4" width="16" height="16" rx="4" fill="#eaf6fa" stroke="#21707b" stroke-width="2"/><path d="M8 12h8M12 8v8" stroke="#21707b" stroke-width="2" stroke-linecap="round"/></svg>
            <svg v-else-if="option.key === 'registro'" width="48" height="48" fill="none" viewBox="0 0 24 24" stroke="#21707b" stroke-width="1.5"><rect x="3" y="5" width="18" height="14" rx="4" fill="#eaf6fa" stroke="#21707b" stroke-width="2"/><path d="M8 9h8M8 13h5" stroke="#21707b" stroke-width="2" stroke-linecap="round"/></svg>
            <svg v-else-if="option.key === 'catalogos'" width="48" height="48" fill="none" viewBox="0 0 24 24" stroke="#21707b" stroke-width="1.5"><rect x="4" y="4" width="16" height="16" rx="4" fill="#eaf6fa" stroke="#21707b" stroke-width="2"/><path d="M8 8h8M8 12h8M8 16h8" stroke="#21707b" stroke-width="2" stroke-linecap="round"/></svg>
          </div>
          <button class="api-option-btn-grid" @click="selectedApi = option.key">
            {{ option.label }}
          </button>
          <div class="api-option-desc-grid">{{ option.description }}</div>
        </div>
      </div>
    </div>
    <div v-else>
      <button class="back-btn" @click="selectedApi = null">← Cambiar API</button>
      <div class="article">
        <div class="container-01" v-if="selectedApi !== 'catalogos'">
          <h5 class="mb-3 mt-2" style="color: white; font-size: x-large;">Selecciona tu API</h5>
          <div>
            <div class="mb-3 d-flex flex-column gap-2">
              <p class="titles">Proyecto</p>
              <select  v-if="proyects.length > 0"  id="week" class="form-select form-select-details text-capitalize" @change="handleProjectChange">
                <option value="0" style="font-weight: 400; color: #99bbd6;" disabled selected>Selecciona un proyecto</option>
                <option v-for="proyect in proyects" :key="proyect.projectsId" :value="proyect.projectsId">{{ proyect.name }}</option>
              </select>
            </div>    
          </div>
          <div>
            <div class="mb-3 d-flex flex-column gap-2">
              <p class="titles">Canal</p>
              <select id="channels" class="form-select form-select-details text-capitalize" v-model="selectedKey" @change="handleKeyChange">
                <option value="0" style="font-weight: 400; color: #99bbd6;" disabled selected>Selecciona una llave</option>
                <option v-for="channel in channelsArray" :key="channel.channelsId" :value="channel.channelsId">{{ channel.name }}</option>
              </select>
            </div>
          </div>
          <div>
            <div class="mb-3 d-flex flex-column gap-2">
              <p class="titles">Tipo de Comunicación</p>
              <select id="channels" class="form-select form-select-details text-capitalize" v-model="selectedMessage" @change="handleTypeChange">
                <option value="0" style="font-weight: 400; color: #99bbd6;" disabled selected>Selecciona una opción</option>
                <option v-for="type in messageArray" :key="type.id" :value="{ id: type.id, text: type.acronym }">{{ type.acronym }}</option>
              </select>
            </div>
          </div>
          <div>
            <p class="titles">Fecha</p>
            <div class="mb-3"> 
              <input type="date" class="form-control globals-input" id="exampleInputEmail3" placeholder="Fecha" @change="handleDateChange">
            </div>
          </div>
        </div>
        <div class="container-02">
          <template v-if="selectedApi === 'evaluacion'">
            <h3 class="mb-3 mt-2" style="text-transform: uppercase; color: #243949; font-weight: 600;">SERVICIO Validar Disponibilidad de Contacto</h3>
            <h4>Descripción</h4>
            <p>Validación para poder contactar a un usuario.</p>
            <h4 class="mb-3" style="color: #243949; font-size: x-large;">SERVICIO A CONTACTAR</h4>
            <h4> Method and Endpoint</h4>
            <div class="base">
              {{ method_endpoint }} 
              <button @click="copyToClipboard(method_endpoint)"  data-bs-toggle="tooltip" title="Copiar en portapapeles">
                <DocumentDuplicateIcon style="height: 20px; width: 20px; color: #517fa4;"></DocumentDuplicateIcon>
              </button>
              <div v-if="isTooltipVisible" class="tooltip">
                Este es un tooltip personalizado.
              </div>
            </div>
            <h4> HOST URL</h4>
            <div class="base">
              https://gcp-api.nateevo.com
              <button @click="copyToClipboard('https://gcp-api.nateevo.com')"  data-bs-toggle="tooltip" title="Copiar en portapapeles">
                <DocumentDuplicateIcon style="height: 20px; width: 20px; color: #517fa4;"></DocumentDuplicateIcon>
              </button>
            </div>
            <h4> Request URL</h4>
            <div class="base">
              {{ url }}
              <button @click="copyToClipboard(url)"  data-bs-toggle="tooltip" title="Copiar en portapapeles">
                <DocumentDuplicateIcon style="height: 20px; width: 20px; color: #517fa4;"></DocumentDuplicateIcon>
              </button>
            </div>
            <h4>Headers Requeridos</h4>
            <div class="base">
              <div>
                <div><span class="letter">Authorization:</span> Bearer {tu_token_api}</div>
                <div><span class="letter">Content-Type:</span> application/json</div>
              </div>
            </div>
            <div class="token-info">
              <InformationCircleIcon style="width: 20px; height: 20px; color: #517fa4;" />
              <span>Tu token API lo puedes encontrar en la sección de Configuración > Credenciales. Si no tienes acceso, contacta a tu administrador.</span>
            </div>
            <h4 > Ejemplo</h4>
            <div class="base-02">
              <div>
                <span class="curl">curl</span>
              </div>
              <div>
                <div><span class="letter">POST</span> /api/v1/contact-service HTTP/1.1</div>
                <div><span class="letter">Host:</span> gcp-api.nateevo.com </div>
                <div><span class="letter">Content-Type:</span> application/json </div>
                <div>{{ url }}</div>
              </div>
            </div>
            <h4 > Data </h4>
            <div class="base"> 
              <!-- AQUI VENDRA LA INFORMACION SELECCIONADA -->
              <div style="font-size: larger;">
                {<br>
                  <span class="data">
                    "project": <span class="number">{{ selectedProject ? selectedProject : '' }}</span> ,<br>
                  </span>
                  <span class="data">
                    "channel": <span class="number">{{ selectedKey ? selectedKey : '' }}</span> ,<br>
                  </span>
                  <span class="data">
                    "value": "{ <span class="number">valor_usuario</span> }",<br>
                  </span>
                  <span class="data">
                    "code":  <span class="number">{{ selectedMessage ? selectedMessage.text : '' }}</span> ,<br>
                  </span>
                  <span class="data">
                    "date": "<span class="number">{{ selectedDate }}</span>"<br>
                  </span>
                }
              </div>
            </div>
          </template>
          <template v-else-if="selectedApi === 'contactabilidad'">
            <h3 class="mb-3 mt-2" style="color: #243949; font-weight: 600;">SERVICIO DE CONTROL DE SEGUIMIENTO</h3>
            <h4 class="mb-3" style="color: #243949; font-size: x-large">
              Servicio Usuario Contactado
            </h4>
            <h4>Method and Endpoint</h4>
            <div class="base">
              POST /api/v1/contact-service-full
              <button
                @click="copyToClipboard(method_endpoint)"
                data-bs-toggle="tooltip"
                title="Copiar en portapapeles"
              >
                <DocumentDuplicateIcon
                  style="height: 20px; width: 20px; color: #517fa4"
                ></DocumentDuplicateIcon>
              </button>
              <div v-if="isTooltipVisible" class="tooltip">
                Este es un tooltip personalizado.
              </div>
            </div>
            <h4>HOST URL</h4>
            <div class="base">
              https://gcp-api.nateevo.com
              <button
                @click="copyToClipboard('https://gcp-api.nateevo.com')"
                data-bs-toggle="tooltip"
                title="Copiar en portapapeles"
              >
                <DocumentDuplicateIcon
                  style="height: 20px; width: 20px; color: #517fa4"
                ></DocumentDuplicateIcon>
              </button>
            </div>
            <h4>Request URL</h4>
            <div class="base">
              https://gcp-api.nateevo.com/api/v1/contact-service-full
              <button
                @click="
                  copyToClipboard(
                    'https://gcp-api.nateevo.com/api/v1/contact-service-full'
                  )
                "
                data-bs-toggle="tooltip"
                title="Copiar en portapapeles"
              >
                <DocumentDuplicateIcon
                  style="height: 20px; width: 20px; color: #517fa4"
                ></DocumentDuplicateIcon>
              </button>
            </div>
            <h4>Headers Requeridos</h4>
            <div class="base">
              <div>
                <div><span class="letter">Authorization:</span> Bearer {tu_token_api}</div>
                <div><span class="letter">Content-Type:</span> application/json</div>
              </div>
            </div>
            <div class="token-info">
              <InformationCircleIcon style="width: 20px; height: 20px; color: #517fa4;" />
              <span>Tu token API lo puedes encontrar en la sección de Configuración > Credenciales. Si no tienes acceso, contacta a tu administrador.</span>
            </div>
            <h4>Ejemplo</h4>
            <div class="base-02">
              <div>
                <span class="curl">curl</span>
              </div>
              <div>
                <div>
                  <span class="letter">POST</span> /api/v1/contact-service-full HTTP/1.1
                </div>
                <div>
                  <span class="letter">Host:</span> gcp-api.nateevo.com
                </div>
                <div><span class="letter">Content-Type:</span> application/json</div>
                <div>https://gcp-api.nateevo.com/api/v1/contact-service-full</div>
              </div>
            </div>
            <h4>Data</h4>
            <div class="base">
              <!-- AQUI VENDRA LA INFORMACION SELECCIONADA -->
              <div style="font-size: larger">
                {<br />
                <span class="data">
                  "project":
                  <span class="number">{{
                    selectedProject ? selectedProject.id : ""
                  }}</span>
                  ,<br />
                </span>
                <span class="data">
                  "channel":
                  <span class="number">{{ selectedKey ? selectedKey : "" }}</span>
                  ,<br />
                </span>
                <span class="data">
                  "value": "{ <span class="number">valor_usuario</span> }",<br />
                </span>
                <span class="data">
                  "code":
                  <span class="number">{{
                    selectedMessage ? selectedMessage.text : ""
                  }}</span>
                  ,<br />
                </span>
                <span class="data">
                  "date": "<span class="number">{{ selectedDate }}</span
                  >"<br />
                </span>
                }
              </div>
            </div>
          </template>
          <template v-else-if="selectedApi === 'registro'">
            <h3 class="mb-3 mt-2" style="text-transform: uppercase; color: #243949; font-weight: 600;">SERVICIO DE Registrar Envío de Contacto</h3>
            <h4 class="mb-3" style="color: #243949; font-size: x-large">
              Servicio Usuario Contactado
            </h4>
            <h4>Method and Endpoint</h4>
            <div class="base">
              POST /api/v1/follow-service
              <button
                @click="copyToClipboard(method_endpoint)"
                data-bs-toggle="tooltip"
                title="Copiar en portapapeles"
              >
                <DocumentDuplicateIcon
                  style="height: 20px; width: 20px; color: #517fa4"
                ></DocumentDuplicateIcon>
              </button>
              <div v-if="isTooltipVisible" class="tooltip">
                Este es un tooltip personalizado.
              </div>
            </div>
            <h4>HOST URL</h4>
            <div class="base">
              https://gcp-api.nateevo.com
              <button
                @click="copyToClipboard('https://gcp-api.nateevo.com')"
                data-bs-toggle="tooltip"
                title="Copiar en portapapeles"
              >
                <DocumentDuplicateIcon
                  style="height: 20px; width: 20px; color: #517fa4"
                ></DocumentDuplicateIcon>
              </button>
            </div>
            <h4>Request URL</h4>
            <div class="base">
              https://gcp-api.nateevo.com/api/v1/follow-service
              <button
                @click="
                  copyToClipboard(
                    'https://gcp-api.nateevo.com/api/v1/follow-service'
                  )
                "
                data-bs-toggle="tooltip"
                title="Copiar en portapapeles"
              >
                <DocumentDuplicateIcon
                  style="height: 20px; width: 20px; color: #517fa4"
                ></DocumentDuplicateIcon>
              </button>
            </div>
            <h4>Headers Requeridos</h4>
            <div class="base">
              <div>
                <div><span class="letter">Authorization:</span> Bearer {tu_token_api}</div>
                <div><span class="letter">Content-Type:</span> application/json</div>
              </div>
            </div>
            <div class="token-info">
              <InformationCircleIcon style="width: 20px; height: 20px; color: #517fa4;" />
              <span>Tu token API lo puedes encontrar en la sección de Configuración > Credenciales. Si no tienes acceso, contacta a tu administrador.</span>
            </div>
            <h4>Ejemplo</h4>
            <div class="base-02">
              <div>
                <span class="curl">curl</span>
              </div>
              <div>
                <div>
                  <span class="letter">POST</span> /api/v1/follow-service HTTP/1.1
                </div>
                <div>
                  <span class="letter">Host:</span> gcp-api.nateevo.com
                </div>
                <div><span class="letter">Content-Type:</span> application/json</div>
                <div>https://gcp-api.nateevo.com/api/v1/follow-service</div>
              </div>
            </div>
            <h4>Data</h4>
            <div class="base">
              <!-- AQUI VENDRA LA INFORMACION SELECCIONADA -->
              <div style="font-size: larger">
                {<br />
                <span class="data">
                  "project":
                  <span class="number">{{
                    selectedProject ? selectedProject.id : ""
                  }}</span>
                  ,<br />
                </span>
                <span class="data">
                  "channel":
                  <span class="number">{{ selectedKey ? selectedKey : "" }}</span>
                  ,<br />
                </span>
                <span class="data">
                  "value": "{ <span class="number">valor_usuario</span> }",<br />
                </span>
                <span class="data">
                  "code":
                  <span class="number">{{
                    selectedMessage ? selectedMessage.text : ""
                  }}</span>
                  ,<br />
                </span>
                <span class="data">
                  "date": "<span class="number">{{ selectedDate }}</span
                  >"<br />
                </span>
                }
              </div>
            </div>
          </template>
          <template v-else-if="selectedApi === 'catalogos'">
            <h3 class="mb-3 mt-2" style="color: #243949; font-weight: 600;">SERVICIOS CATÁLOGOS</h3>
            <h4>Descripción</h4>
            <p>Este endpoint permite obtener la información detallada de todos los proyectos, incluyendo sus canales y comunicaciones asociadas. La respuesta incluye datos como el nombre del proyecto, límites de contacto diario, puntos límite y estado. Estos datos te serviran para genear el payload de los servicios de contactabilidad y seguimiento.</p>
            
            <h4>Method</h4>
            <div class="base">
              GET
            </div>
            <h4>Endpoint</h4>
            <div class="base">
              https://gcp-api.nateevo.com/api/v1/project/api
              <button @click="copyToClipboard('https://gcp-api.nateevo.com/api/v1/project/api')" data-bs-toggle="tooltip" title="Copiar en portapapeles">
                <DocumentDuplicateIcon style="height: 20px; width: 20px; color: #517fa4;"></DocumentDuplicateIcon>
              </button>
            </div>
            <h4>Headers Requeridos</h4>
            <div class="base">
              <div>
                <div><span class="letter">Authorization:</span> Bearer {tu_token_api}</div>
                <div><span class="letter">Content-Type:</span> application/json</div>
              </div>
            </div>
            <div class="token-info">
              <InformationCircleIcon style="width: 20px; height: 20px; color: #517fa4;" />
              <span>Tu token API lo puedes encontrar en la sección de Configuración > Credenciales. Si no tienes acceso, contacta a tu administrador.</span>
            </div>

            <h4 class="mt-4">Ejemplo de uso con curl</h4>
            <div class="base-02">
              <div>
                <span class="curl">curl</span>
              </div>
              <div>
                <div><span class="letter">GET</span> https://gcp-api.nateevo.com/api/v1/project/api HTTP/1.1</div>
                <div><span class="letter">Host:</span> gcp-api.nateevo.com</div>
                <div><span class="letter">Authorization:</span> Bearer {tu_token_api}</div>
                <div><span class="letter">Content-Type:</span> application/json</div>
              </div>
            </div>

            <h4 class="mt-4">Ejemplo de respuesta</h4>
            <div class="base">
              <div style="font-size: larger;">
                {<br>
                  <span class="data">
                    "projects": [<br>
                    &nbsp;&nbsp;{<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;<span class="letter">"projectsId"</span>: <span class="number">1</span>,<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;<span class="letter">"name"</span>: <span class="string">"Proyecto Ejemplo"</span>,<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;<span class="letter">"timesContactDaily"</span>: <span class="number">100</span>,<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;<span class="letter">"channels"</span>: [<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="letter">"channelsId"</span>: <span class="number">1</span>,<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="letter">"name"</span>: <span class="string">"Email"</span>,<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="letter">"description"</span>: <span class="string">"Canal de correo electrónico"</span><br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;}<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;],<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;<span class="letter">"communications"</span>: [<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="letter">"id"</span>: <span class="number">1</span>,<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="letter">"name"</span>: <span class="string">"Notificación"</span>,<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="letter">"acronym"</span>: <span class="string">"NOT"</span>,<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="letter">"points"</span>: <span class="number">10</span><br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;}<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;]<br>
                    &nbsp;&nbsp;}<br>
                    ]<br>
                  </span>
                }
              </div>
            </div>
            <div class="token-info">
              <InformationCircleIcon style="width: 20px; height: 20px; color: #517fa4;" />
              <span>La respuesta incluye un array de proyectos, cada uno con su ID, nombre, límite de contactos diarios, canales disponibles y tipos de comunicaciones permitidas.</span>
            </div>

            <h4 class="mt-4">Explorar catálogos</h4>
            <div class="catalog-container mt-4">
              <div class="catalog-lists">
                <div class="catalog-list">
                  <h4>Proyectos</h4>
                  <div class="list-content">
                    <div v-for="proyect in proyects" 
                         :key="proyect.projectsId" 
                         class="list-item"
                         :class="{ active: selectedProject === proyect.projectsId }"
                         @click="handleProjectChange({ target: { value: proyect.projectsId }})">
                      <div class="list-item-content">
                        <div class="list-item-title">{{ proyect.name }}</div>
                        <div class="list-item-subtitle">
                          Contactos diarios: {{ proyect.timesContactDaily }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="catalog-list">
                  <h4>Canales</h4>
                  <div class="list-content">
                    <div v-for="channel in channelsArray" 
                         :key="channel.channelsId" 
                         class="list-item"
                         :class="{ active: selectedKey === channel.channelsId }"
                         @click="handleKeyChange({ target: { value: channel.channelsId }})">
                      <div class="list-item-content">
                        <div class="list-item-title">{{ channel.name }}</div>
                        <div class="list-item-subtitle">{{ channel.description }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="catalog-list">
                  <h4>Comunicaciones</h4>
                  <div class="list-content">
                    <div v-for="comm in messageArray" 
                         :key="comm.id" 
                         class="list-item"
                         :class="{ active: selectedMessage && selectedMessage.id === comm.id }"
                         @click="handleTypeChange({ target: { value: comm.id }})">
                      <div class="list-item-content">
                        <div class="list-item-title">{{ comm.name }}</div>
                        <div class="list-item-subtitle">
                          {{ comm.acronym }} - {{ comm.points }} puntos
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "@/_scss/global/_variables.scss";
.data {
  padding-left: 1rem;
  .number {
    color: $secondary-color;
    font-weight: 600;
  }
}
.letter {
  color: $eight-color;
  margin-right: 10px;
}
.curl {
  margin-right: 15px;
  color: $nine-color;
}
.container-02 {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 2rem;
  width: 100%;
  h4 {
    color: $primary-color;
    font-weight: 600;
  }
  .base {
    display: flex;
    justify-content: space-between;
    background: $white-color;
    border-radius: 5px;
    color: $six-color;
    padding: 5px 10px;
    font-family: "Hind", sans-serif;
    font-style: oblique;
    width: auto;
    max-width: 80%;
    button {
      background: transparent;
      border: none;
      cursor: pointer;
    }
  }
  .base-02 {
    display: flex;
    background: $third-color;
    border-radius: 5px;
    color: $white-color;
    padding: 5px 10px;
    font-family: "Hind", sans-serif;
    font-style: oblique;
    width: auto;
    max-width: 80%;
  }
}
.titles {
  font-size: medium;
  font-weight: 600;
}
.article {
  display: flex;
  background-color: $fourth-color;
  border-radius: 15px;
  margin-bottom: 20px;
  margin-top: 20px;
  padding: 10px;
}
.container-01 {
  background: $primary-color;
  border-radius: 20px;
  box-shadow: 0px 6px 10px $shadow-color;
  color: $white-color;
  font-size: larger;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 30%;
  height: 100%;
  padding: 4rem 2rem;
}
.api-selection {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 2rem 0;
  h2 {
    margin-bottom: 2rem;
    color: #243949;
  }
  .api-options-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    width: 100%;
    align-items: stretch;
    margin-top: 2rem;
  }
  @media (max-width: 1100px) {
    .api-options-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  @media (max-width: 700px) {
    .api-options-grid {
      grid-template-columns: 1fr;
    }
  }
  .api-option-block-grid {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #fff;
    border-radius: 18px;
    box-shadow: 0 2px 8px rgba(33,112,123,0.08);
    padding: 2.2rem 1.5rem 1.5rem 1.5rem;
    transition: box-shadow 0.2s, transform 0.2s;
    cursor: pointer;
    min-height: 320px;
    border: 2px solid transparent;
  }
  .api-option-block-grid:hover {
    box-shadow: 0 4px 16px rgba(33,112,123,0.16);
    border: 2px solid #21707b;
    transform: translateY(-4px) scale(1.03);
  }
  .api-option-img {
    margin-bottom: 1.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 56px;
  }
  .api-option-btn-grid {
    padding: 1rem 1.5rem;
    font-size: 1.1rem;
    border-radius: 12px;
    border: none;
    background: #034559;
    color: #fff;
    font-weight: 700;
    cursor: pointer;
    margin-bottom: 1rem;
    margin-top: 0.5rem;
    width: 100%;
    transition: background 0.2s;
  }
  .api-option-btn-grid:hover {
    background: #022c36;
  }
  .api-option-desc-grid {
    margin-top: 0.7rem;
    color: #444;
    font-size: 1rem;
    text-align: center;
    max-width: 420px;
    line-height: 1.4;
  }
}
.back-btn {
  margin-bottom: 1rem;
  background: none;
  border: none;
  color: #21707b;
  font-size: 1rem;
  cursor: pointer;
}
.example-image {
  margin-top: 1rem;
  padding: 1rem;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}
.catalog-container {
  padding: 1rem;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}
.catalog-lists {
  display: flex;
  gap: 2rem;
  margin-top: 1rem;
}
.catalog-list {
  flex: 1;
  min-width: 200px;
  
  h4 {
    color: #243949;
    font-weight: 600;
    margin-bottom: 1rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #517fa4;
  }
}
.list-content {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 0.5rem;
  max-height: 400px;
  overflow-y: auto;
}
.list-item {
  padding: 0.75rem 1rem;
  margin: 0.25rem 0;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #243949;
  
  &:hover {
    background: #e9ecef;
  }
  
  &.active {
    background: #517fa4;
    color: white;
  }
}
.list-item-content {
  .list-item-title {
    font-weight: 500;
    margin-bottom: 0.25rem;
  }
  
  .list-item-subtitle {
    font-size: 0.875rem;
    color: #6c757d;
  }
}
.list-item.active {
  .list-item-subtitle {
    color: rgba(255, 255, 255, 0.8);
  }
}
.token-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
  color: #6c757d;
  font-size: 0.875rem;
}
</style>
